import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

import { GoogleAnalyticsService } from '@app/services/_index';
import { HasAnalytics } from '@app/interfaces/_index';
import { logGoogleAnalytics } from '@app/utilities/_index';

@Component({
  selector: 'app-static-page',
  templateUrl: './static-page.component.html',
  styleUrls: ['./static-page.component.scss'],
  standalone: false,
})
export class StaticPageComponent implements OnInit, AfterViewInit, HasAnalytics {
  @Input() title: string;
  @Input() bodyContent: string; // NOTE: CMS contains HTML formatted content with the body

  @ViewChild('iframe') iframe: ElementRef;

  constructor(private googleAnalyticsService: GoogleAnalyticsService) {}

  /**
   * Default OnInit
   */
  // TODO: Remove ngOnInit if not needed in future review
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}

  /**
   * Send the query search label to Google Analytics
   * @param category - the source of the google analytics category string (ex. the page or component triggering the action)
   * @param action - the action to be (ex. click)
   * @param dataLabel - the label associated with the action
   */
  sendGoogleAnalytics(category: string, action: string, dataLabel: string): void {
    logGoogleAnalytics(category, action, dataLabel);
    this.googleAnalyticsService.sendEvent(category, action, dataLabel);
  }

  /**
   * On After View Int - scan the dynamic html response from CMS and
   * dynamically create click event listeners and attach to the matching
   * HTMLAnchorElements that match "a" which are links.
   */
  ngAfterViewInit(): void {
    const htmlResponseBody = document.querySelector('.htmlresponse');
    const matchingLinks = htmlResponseBody.querySelectorAll('a');
    if (matchingLinks && matchingLinks.length > 0) {
      matchingLinks.forEach((itemLink) => {
        // NOTE: Dynamicaly add a click event listener to the dom html anchor
        // element that matches from the html response from CMS
        itemLink.addEventListener('click', this.onClick.bind(this));
      });
    }
    const matchingIframes = htmlResponseBody.querySelectorAll('iframe');
    if (matchingIframes && matchingIframes.length > 0) {
      matchingIframes.forEach((iframeItem) => {
        const contentWindow = iframeItem.contentWindow;
        if (contentWindow) {
          const windowDocument = contentWindow.document;
          if (windowDocument) {
            const windowBody = windowDocument.body;
            if (windowBody) {
              // TODO: Fix this in future release.
              const test: HTMLElement = iframeItem.contentDocument.getElementsByTagName('body')[0];
              windowBody.addEventListener('click', this.onClick.bind(this));
            }
          }
        }
      });
    }
  }

  /**
   * OnClick - Handle dynamic link clicks and send Google Analytics based
   * on the HTMLAnchorElement inner text.
   */
  onClick(event: Event): void {
    const htmlText = event.target as HTMLAnchorElement;
    this.sendGoogleAnalytics('cms', 'click', htmlText.innerText);
  }
}
